export const minimumCharacterValidationMessage = 'Minimum of 1 character is required for the banner';
export const maximumCharacterValidationMessage = 'Maximum amount of characters exceeded';
